// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7776 ? "477d4af2" : chunkId) + "." + {"7776":"85d4ae50dec064b5","8699":"890613b27191ec76"}[chunkId] + ".js";
};